import React, {Component} from 'react';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import ReactTooltip from 'react-tooltip';
import settings from '../../utils/settings';

class SendingProgress extends Component {
    render() {
        return (
            <div className="tagfeedbackcontrol-sending">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;&nbsp;Sending ...
            </div>
        );
    }
}

class TagFeedbackControl extends Component {
    constructor(props){
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onDeleteNew = this.onDeleteNew.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.getTagValues = this.getTagValues.bind(this);
        this.onSelectNewTag = this.onSelectNewTag.bind(this);
        this.onSaveOldTag = this.onSaveOldTag.bind(this);

        this.state = {
            error: '',
            sending: false,
            tags: this.props.tags,
            tagModel: settings.getValue('tagModel', 'dau'),
            newTags: []
        };

        this.feedbackDisable = window._feedbackDisable;
        this.feedbackModels = ['dau'];

        this.tagValues = {
            'dau': [
                'topic area|acquisition-management|acquisition',
                'topic area|acquisition-management|acquisition-environment',
                'topic area|acquisition-management|acquisition-phase',
                'topic area|acquisition-management|acquisition-planning',
                'topic area|acquisition-management|acquisition-program',
                'topic area|contracting|contract-administration',
                'topic area|contracting|contract-types-and-incentives',
                'topic area|contracting|cost-analysis',
                'topic area|contracting|negotiation',
                'topic area|contracting|source-selection',
                'topic area|cost-estimating|cost-analysis',
                'topic area|cost-estimating|cost-estimating-process',
                'topic area|cost-estimating|cost-estimating-relationship',
                'topic area|cost-estimating|economic',
                'topic area|cost-estimating|life-cycle-cost-estimate',
                'topic area|cybersecurity|availability',
                'topic area|cybersecurity|confidentiality',
                'topic area|cybersecurity|cyber-resilience',
                'topic area|cybersecurity|integrity',
                'topic area|cybersecurity|system-security-engineering',
                'topic area|earned-value-management|cost-variance',
                'topic area|earned-value-management|estimate-at-completion',
                'topic area|earned-value-management|integrated-master-schedule',
                'topic area|earned-value-management|performance-measurement-baseline',
                'topic area|earned-value-management|schedule-variance',
                'topic area|engineering|aerodynamics',
                'topic area|engineering|design',
                'topic area|engineering|digital-engineering',
                'topic area|engineering|systems-engineering',
                'topic area|facilities-engineering|construction',
                'topic area|facilities-engineering|design',
                'topic area|facilities-engineering|facilities-planning',
                'topic area|facilities-engineering|facilities-sustainment',
                'topic area|facilities-engineering|real-estate',
                'topic area|financial-management|accounting-and-audit-readiness',
                'topic area|financial-management|budget-execution',
                'topic area|financial-management|budget-formulation-and-presentation',
                'topic area|financial-management|congressional-enactment',
                'topic area|financial-management|fiscal-law',
                'topic area|industrial-contract-property-management|disposition',
                'topic area|industrial-contract-property-management|government-contract-property',
                'topic area|industrial-contract-property-management|government-property',
                'topic area|industrial-contract-property-management|property-system',
                'topic area|information-technology|data-management',
                'topic area|information-technology|it-service-management',
                'topic area|information-technology|software-development',
                'topic area|information-technology|software-sustainment',
                'topic area|information-technology|software-test',
                'topic area|international-acquisition-management|defense-exportability',
                'topic area|international-acquisition-management|defense-sales-and-transfers',
                'topic area|international-acquisition-management|ia&e-planning-and-analysis',
                'topic area|international-acquisition-management|international-contracting',
                'topic area|international-acquisition-management|international-cooperative-programs',
                'topic area|international-acquisition-management|technology-security-and-foreign-disclosure',
                'topic area|logistics|integrated-product-support',
                'topic area|logistics|life-cycle-sustainment',
                'topic area|logistics|performance-based-logistics',
                'topic area|logistics|product-support',
                'topic area|production-quality-manufacturing|manufacturing',
                'topic area|production-quality-manufacturing|production',
                'topic area|production-quality-manufacturing|quality',
                'topic area|program-management---general-acquisition|cost',
                'topic area|program-management---general-acquisition|leadership',
                'topic area|program-management---general-acquisition|performance',
                'topic area|program-management---general-acquisition|risk-management',
                'topic area|program-management---general-acquisition|schedule',
                'topic area|purchasing|purchase-cards',
                'topic area|purchasing|purchasing',
                'topic area|purchasing|simplified-acquisitions',
                'topic area|requirements-management|capability-requirements-document',
                'topic area|requirements-management|interoperability',
                'topic area|requirements-management|joint-urgent-operational-need',
                'topic area|requirements-management|operational-attributes',
                'topic area|requirements-management|performance-attributes',
                'topic area|requirements-management|threat-assessment',
                'topic area|science-and-technology|research',
                'topic area|science-and-technology|technology-assessment',
                'topic area|science-and-technology|technology-development',
                'topic area|science-and-technology|technology-transition-agreement',
                'topic area|services-acquisition|acquisition-strategy',
                'topic area|services-acquisition|functional-service-manager',
                'topic area|services-acquisition|it-services',
                'topic area|services-acquisition|performance-work-statement',
                'topic area|services-acquisition|quality-assurance-surveillance-plan',
                'topic area|services-acquisition|senior-services-manager',
                'topic area|small-business|set-asides',
                'topic area|small-business|small-business-participation-evaluation',
                'topic area|small-business|small-business-professional',
                'topic area|small-business|small-business-programs',
                'topic area|small-business|small-business-subcontracting',
                'topic area|test-and-evaluation|developmental-test-and-evaluation',
                'topic area|test-and-evaluation|integrated-test',
                'topic area|test-and-evaluation|live-fire-test-and-evaluation',
                'topic area|test-and-evaluation|operational-test-and-evaluation',
                'topic area|test-and-evaluation|test-and-evaluation-master-plan'
            ]
        }
    };

    componentDidMount() {
        this.setState({
            tagModel: settings.getValue('tagModel', 'dau')
        })
    }

    handleSubmit() {
        this.setState({sending: true});

        urlHandler.submitTagFeedback(
            {
                assigned_tags: JSON.stringify(this.props.tags,null,4),
                feedback_tags: JSON.stringify(this.state.tags.concat(this.state.newTags),null,4),
                comment: this.refs.comment.value,
                content: this.props.text
            }
        ).then((response) => {
            console.log(response.data);
            this.setState({
                sending: false,
                error: ''
            })
        }).catch((err) => {
            console.log(err.response.data);
            this.setState({
                sending: false,
                error: err.response.data
            })
        });
    };

    onDelete(tag) {
        this.setState({
            tags: this.state.tags.filter(function(t) {
                return (t.label !== tag.label);
            })
        })
    }

    onDeleteNew(tag) {
        this.setState({
            newTags: this.state.newTags.filter(function(t) {
                return (t.label !== tag.label);
            })
        })
    }

    onAdd() {
        let available = this.getTagValues(this.state.tagModel);
        if (available.length > 0) {
            let nt = this.state.newTags;
            nt.push({
                label: available[0]
            })
            this.setState({
                newTags: nt
            })
        }
    }

    onSelectNewTag(e) {
        let oldValue = e.target.getAttribute('oldvalue');
        let newValue = e.target.value;
        
        let nt = this.state.newTags;
        if (oldValue) {
            nt = nt.filter((el) => {
                return el.label != oldValue;
            })
        }
        nt.push({
            label: newValue
        })
        this.setState({
            newTags: nt
        })
    }

    onSaveOldTag(e) {
        e.target.setAttribute('oldvalue', e.target.value);
    }

    getTagValues(model, ignore=null) {
        var values = this.tagValues[model].filter((val) => {
            if (ignore && ignore === val) {
                return true;
            }
            if (this.state.tags.find((x) => x.label === val) || this.state.newTags.find((x) => x.label === val)) {
                return false;
            }
            return true;
        })
        return values;
    }

    render() {
        return (
           <div>
                <div className="tagfeedbackcontrol-dialog">
                    <div className="tagfeedbackcontrol-description">
                        {this.feedbackModels.includes(this.state.tagModel) && !this.feedbackDisable &&
                            <span>
                                Click the delete icon to the right to remove any tag that should not be associated. You may also 
                                add additional tags.
                            </span>
                        }
                    </div>
                    <div className="tagfeedbackcontrol-content">
                        <div className="tagfeedbackcontrol-form">
                            {this.state.tags &&
                                <div className='form-field-wrapper text-field'>
                                    <label htmlFor='typesField' className='form-label tagfeedbackcontrol-form-label'>Tags:</label>
                                    <div id="typesField"> 
                                        <div>
                                            <div>
                                                {this.state.tags.map((tag, indx) =>
                                                    <div className="tagfeedbackcontrol-entities-item" key={`${tag.name ? tag.name : tag.label}-${indx}`}>
                                                        <span className="fa fa-tag" style={{marginRight: '5px'}}></span>
                                                        <span data-tip={`Score: ${Number(tag.score).toFixed(4)}`}>{tag.name ? tag.name : tag.label}</span>       
                                                        {this.feedbackModels.includes(this.state.tagModel) && !this.feedbackDisable &&                                                 
                                                            <span className="fa fa-window-close tag-delete-item" onClick={() => this.onDelete(tag)}></span> 
                                                        }
                                                    </div>
                                                )}
                                                <ReactTooltip type="dark" effect="solid" place="top" offset={{'top': -10}}/>
                                            </div>
                                            {this.feedbackModels.includes(this.state.tagModel) && !this.feedbackDisable &&
                                                <div style={{marginTop: '15px'}}>
                                                    {this.state.newTags.map((val, idx) => 
                                                        <table key={idx} style={{width: '100%'}}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <select className="form-field" value={val.label} style={{marginBottom: '7px'}} onChange={this.onSelectNewTag} onClick={this.onSaveOldTag}>
                                                                            {this.getTagValues(this.state.tagModel, val.label).map((tag) =>
                                                                                <option key={tag} value={tag}>{tag}</option>    
                                                                            )}
                                                                        </select>
                                                                    </td>
                                                                    <td style={{verticalAlign: 'top'}}>
                                                                        <span className="fa fa-window-close tag-delete-item" onClick={() => this.onDeleteNew(val)}></span>   
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    )}
                                                    <button type="button" className="tag-add-button" onClick={this.onAdd}>Add Tag</button> 
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.feedbackModels.includes(this.state.tagModel) && !this.feedbackDisable &&
                                <div className='form-field-wrapper text-field'>
                                    <label htmlFor='issueField' className='form-label tagfeedbackcontrol-form-label'>Comments:</label>
                                    <textarea className='form-field tagfeedbackcontrol-textarea tagfeedbackcontrol-form-field'
                                            name='comment'
                                            id='commentField'
                                            ref='comment'
                                    />
                                </div>
                            }
                            <br/>
                            <span className="tagfeedbackcontrol-error-msg">{this.state.error}</span>
                        </div>
                    </div>
                    {this.feedbackModels.includes(this.state.tagModel) && !this.feedbackDisable &&
                        <div className="tagfeedbackcontrol-footer">
                            {this.state.sending ? <SendingProgress /> : null}
                            <button type="button" className="tagfeedbackcontrol-default-button" onClick={this.handleSubmit}>Submit Feedback</button>
                        </div>
                    }
                </div>
            </div>
        );
    };
}

TagFeedbackControl.propTypes = {
    tags: PropTypes.array,
    text: PropTypes.string
};

export default TagFeedbackControl;


